// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__8A2y4","invisible":"Timeline_invisible__oZTF-","value":"Timeline_value__WkKRB","point":"Timeline_point__J-ozM"};